import "react-toastify/dist/ReactToastify.css";
import { Card } from "reactstrap";
import "../Orders.scss";
import invoice from "../../../../assets/images/invoice.svg";
import timer from "../../../../assets/images/timer.svg";
import drop from "../../../../assets/images/dropIcon.svg";
import yollow from "../../../../assets/images/yollwoDot.svg";
import viewMOre from "../../../../assets/images/viewMore.svg";
import tick from "../../../../assets/images/tick.svg";
import smjText from "../../../../assets/images/message-text.png";
import boxRider from "../../../../assets/images/box-rider.png";
import { SetStateAction, useEffect, useState } from "react";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import VideoProofModal from "./VideoProofModal";
import {
  FirebaseAuthBackend,
  getFirebaseBackend,
} from "helpers/firebase_helper";
import { getActivies, updateOrderTime } from "live-slices/thunk";
import ExtendTimeModal from "./ExtendTimeModal";
import proof from "../../../../assets/images/proof.png";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import TrackOrderMOdal from "./TrackOrder";
import close from "../../../../assets/images/color.png";
import clock from "../../../../assets/images/clock.png";
import yellowTick from "../../../../assets/images/yellow.png";
import rider from "../../../../assets/images/biyeaRider.png";
import ErrorModal from "Components/Common/ErrorModal";
import VideoViewer from "Components/Common/VideoViewer";
import add from "../../../../assets/images/add-square.png";
// @ts-ignore
import alertSound from "../../../../assets/audio/alert.mp3";
import { Link } from "react-router-dom";
import index from "pages/Email/EmailTemplates/BasicAction";
import { Environment } from "environment";
import { getS3Upload } from "helpers/backend_helper";

const OrderHistory = (props: any) => {
  const OnboardingTabs = [
    {
      label: "About Campaign",
      value: "isStoreCreated",
      heading: "About Campaign",
    },
    {
      label: "Add Product",
      value: "isAddressAdded",
      heading: "Add Product",
    },
    {
      label: "Add Influencer",
      value: "isIdBankDetails",
      heading: "Add Influencer",
    },
    {
      label: "Add Brief",
      value: "isIdBankDetails",
      heading: "Add Brief",
    },
  ];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user
  );
  const user = useSelector(selectUser);
  const [proofModal, setProofModal] = useState(false);
  const firebaseHelper: FirebaseAuthBackend | null = getFirebaseBackend();
  const [newValueInfo, setNewValueInfo] = useState<boolean>(false);
  const dispatch: any = useDispatch();
  const [trackOrderModal, setTrackOrderModal] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [isViewerOpen, setViewerOpen] = useState(false);

  const selecteOrderData = createSelector(
    (state: any) => state.Orders,
    (activies) => activies?.activies
  );

  const activities = useSelector(selecteOrderData);

  useEffect(() => {
    console.log(activities);
  }, []);

  useEffect(() => {
    if (trackOrderModal || props.order.status === "riderAssigned") {
      dispatch(getActivies({ orderId: props.order._id }));
      console.log(activities);
    }
  }, [trackOrderModal]);

  const toggleOption = () => {
    if (newValueInfo === true) {
      setNewValueInfo(false);
    } else {
      setNewValueInfo(true);
    }
  };

  var [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
  }, [props?.order?.preparingTime, props?.order?.orderAcceptTime]);

  useEffect(() => {
    let audio: HTMLAudioElement | null = null;

    if (
      props?.order?.status === "orderPlaced" &&
      props?.order?.preparingTime === 0 &&
      typeof timeLeft === "number" &&
      timeLeft <= 300 &&
      timeLeft > 0
    ) {
      audio = new Audio(alertSound);
      audio.loop = true;
      audio.play().catch((err) => console.error("Sound play failed", err));
      // Save audio instance to window for later pause
      (window as any).__orderAlertAudio = audio;
    }

    if (props?.order?.status === "orderAccepted") {
      const playingAudio = (window as any).__orderAlertAudio as HTMLAudioElement | undefined;
      if (playingAudio) {
        playingAudio.pause();
        playingAudio.currentTime = 0;
        (window as any).__orderAlertAudio = null;
      }
    }

    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.key === "orderAccepted" &&
        event.newValue === props?.order?._id
      ) {
        const playingAudio = (window as any).__orderAlertAudio as
          | HTMLAudioElement
          | undefined;
        if (playingAudio) {
          playingAudio.pause();
          playingAudio.currentTime = 0;
          (window as any).__orderAlertAudio = null;
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
        (window as any).__orderAlertAudio = null;
      }
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [timeLeft, props.order?.status]);

  const calculateTimeLeft = () => {
    if (
      props?.order?.preparingTime === 0 &&
      props?.order?.status === "orderPlaced"
    ) {
      const now = Date.now();
      const diff = Math.max(props?.order.orderAcceptTime - now, 0);
      return Math.floor(diff / 1000);
    } else {
      const now = Date.now();
      const diff = Math.max(props?.order.preparingTime - now, 0);
      return Math.floor(diff / 1000);
    }
  };

  useEffect(() => {
    if (timeLeft === null || timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    } else {
      return `${minutes}:${String(secs).padStart(2, "0")}`;
    }
  };

   const getUploadUrl = async (file: File): Promise<string | null> => {
        try {
            const fileName = encodeURIComponent(file.name);

            const res: any = await getS3Upload(fileName,file.type); // Your API returns { uploadUrl }
            const uploadUrl = res?.data?.uploadUrl;

            if (uploadUrl) {

                const myHeaders = new Headers();
                myHeaders.append("Content-Type", file.type);
                const requestOptions: any = {
                    method: "PUT",
                    headers: myHeaders,
                    body: file,
                    redirect: "follow"
                };
                await fetch(uploadUrl, requestOptions);
            }

            return res.data.fileUrl;
        } catch (err) {
            console.error("S3 upload error", err);
            return null;
        }
    };

  const handleSubmit = async (videos: File[]) => {
    const newOrderPackageImages = await Promise.all(
      videos.map(async (video) => {
      const url = await getUploadUrl(video);
        if (url) {
          return {
            url: url,
            metaData: {
              height: 0,
              width: 0,
              fileType: video.type,
              fileFormat: video.name.split(".").pop() || "",
              name: video.name,
              duration: 0,
            },
          };
        }
      })
    );

    const existingImages = props?.order?.orderPackageImage ?? [];

    const updatedOrderPackageImages = [
      ...existingImages,
      ...newOrderPackageImages,
    ];

    const response = await dispatch(
      updateOrderTime({
        orderId: props?.order?._id,
        orderPackageImage: updatedOrderPackageImages,
      })
    );

    if (response) {
      onGetOrders();
      window.location.reload();
    }

    console.log("Processed Data:", updatedOrderPackageImages);
    setProofModal(false);
  };

  const handleProof = async () => {
    toast.error("Please Approve Video Proof First!", { autoClose: 1000 });
  };

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const handleButton = async (status: any) => {
    if (
      props?.order &&
      props?.order?.orderPackageImage &&
      props?.order?.orderPackageImage?.length
    ) {
      const response = await dispatch(
        updateOrderTime({
          orderId: props?.order?._id,
          status: status,
        })
      );
      if (response) {
        onGetOrders();
      }
    } else {
      toast.error("Please Approve Video Proof First!", { autoClose: 1000 });
    }
  };

  const [confirmModal, setConfirmModal] = useState(false);

  // useEffect(() => {
  //   onGetOrders();
  // }, [confirmModal]);

  const formatStatus = (status: any) => {
    if (!status) return "Unknown Status";

    return status
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str: any) => str.toUpperCase());
  };

  const formattedStatus = formatStatus(props?.order?.status);

  const onGetOrders = async () => {
    try {
      const response = await axios.get(
        `api/v1/order/sellerorders?page=${1}&count=${10}&status=${
          props.activeTab
        }`
      );
      if (response?.data) {
        props.setOrders(response.data.data);
        props.setTotalPages(Math.ceil(response.data.totalCount / 10));
      }
    } catch (err: any) {
    } finally {
    }
  };

  const openPicklist = (id: any) => {
    const url = `${Environment.EnvrionmentUrl}/external/picklist/${id}`;
    window.open(url, "_blank");
  };

  const openRiderHandover = (id: any) => {
    const url = `${Environment.EnvrionmentUrl}/external/riderInvoice/${id}`;
    window.open(url, "_blank");
  };

  const openrAwb = (id: any) => {
    const url = `${Environment.EnvrionmentUrl}/external/awb/${id}`;
    window.open(url, "_blank");
  };

  const openInvoice = (id: any) => {
    const url = `${Environment.EnvrionmentUrl}/external/summaryPurchase/${id}`;
    window.open(url, "_blank");
  };

  const openViewer = (videoUrl: string) => {
    setCurrentImage(videoUrl);
    setViewerOpen(true);
  };

  // const [imageUrl, setImageUrl] = useState(props && props?.order && props?.order?.orderPackageImage?.length && props?.order?.orderPackageImage[0]?.url || "");

  const [orderImages, setOrderImages] = useState(
    props?.order?.orderPackageImage || []
  );

  useEffect(() => {
    console.log(props.order._id, props.order.orderPackageImage);
  }, [props]);

const handleClearImage = async (index: number) => {
  const nextImages = orderImages.filter((_: any, i: number) => i !== index);
  setOrderImages(nextImages);
  try {
    if (nextImages) {
      await dispatch(
        updateOrderTime({
          orderId: props.order?._id,
          orderPackageImage: nextImages,
        })
      );
    }
  } catch (err) {
    console.error('updateOrderTime failed', err);
  }
};

  return (
    <>
      <ToastContainer />
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <VideoProofModal
        show={proofModal}
        onCloseClick={() => setProofModal(false)}
        onSubmit={handleSubmit}
        orderId={props?.order?.buypassId}
      />

      <TrackOrderMOdal
        show={trackOrderModal}
        onCloseClick={() => setTrackOrderModal(false)}
        activities={activities}
        order={props.order}
      />

      <ExtendTimeModal
        show={confirmModal}
        onCloseClick={setConfirmModal}
        orderDetail={props.order}
      />
      <VideoViewer
        isOpen={isViewerOpen}
        videoUrl={currentImage}
        toggle={closeViewer}
      />
      <Card
        className={`orderCardBox ${
          props.order?.isResponseTimeExtended === false &&
          props?.order?.status === "orderPlaced" &&
          timeLeft !== null &&
          timeLeft < 300
            ? "RedishColour"
            : ""
        }`}
      >
        <div className=" d-md-flex justify-content-between align-items-start mb-3">
          <div className="profileRow">
            <div className="itemDv">
              <i className="bx bxs-user mobile-hide"></i>
              {/* <p className="modile-show">User</p> */}
              <h3>{props?.order?.userDetails?.name}</h3>
            </div>
            <div className="itemDv">
              <p>Order ID:</p>
              <h4>
                {props?.order.buypassId}

                <i
                  className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer"
                  data-testing-id="copyIdIcon_order"
                  onClick={() => {
                    navigator.clipboard.writeText(props?.order?.buypassId);
                    // toast.success("Order ID copied!", { autoClose: 1000 });
                    setShowModal({ isVisible: true, color: true });
                    setErrorMessage("Order ID Copied!");
                    setTimeout(() => {
                      setShowModal({ isVisible: false, color: true });
                    }, 1000);
                  }}
                ></i>
              </h4>
            </div>
            <div className="itemDv">
              <p>QTY:</p>
              <h4>
                {props?.order?.items?.reduce(
                  (total: number, item: any) => total + (item.quantity || 0),
                  0
                )}
              </h4>
            </div>

            <div className="itemDv">
              <p>Create Time:</p>
              <h4>
                {new Date(props?.order?.createdOn).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  // second: "2-digit",
                  hour12: true,
                })}
              </h4>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 actionBtnBox w-52">
            <div className="actionDv">
              <div className="timerDv">
                {(props?.order.status === "orderPlaced" ||
                  props?.order.status === "orderAccepted") && (
                  <>
                    {timeLeft !== 0 && (
                      <div className="timingDv ">
                        <img src={timer} alt="" />
                        <h4>
                          {formatTime(timeLeft ? timeLeft : 0)}{" "}
                          <span>left</span>
                        </h4>
                      </div>
                    )}
                  </>
                )}
                {props?.order?.status === "orderPlaced" &&
                  timeLeft !== null &&
                  timeLeft < 300 &&
                  timeLeft > 0 && (
                    <div className="timeOutDv ">
                      <p>Hurry up accept your order to avoid cancellation</p>
                    </div>
                  )}

                {props?.order?.status === "orderAccepted" &&
                  timeLeft !== null &&
                  timeLeft < 300 &&
                  timeLeft > 0 && (
                    <>
                      <div className="timeOutDv ">
                        <p>Hurry up prepare your order</p>
                      </div>
                    </>
                  )}

                {newValueInfo === true &&
                  timeLeft === 0 &&
                  !props.order?.isResponseTimeExtended &&
                  props?.order?.status === "orderPlaced" && (
                    <div
                      className="timeOutDv "
                      onClick={() => setConfirmModal(true)}
                    >
                      <div className="extendTime">
                        Extend Time
                        <img src={drop} className="dropIcon" alt="" />
                      </div>
                    </div>
                  )}
              </div>
            </div>
            {(props?.order.status === "readyToShip" ||
              props?.order.status === "riderAssigned" ||
              props?.order.status === "orderPickedUp" ||
              props?.order.status === "riderReached") && (
              <button
                type="button"
                className="btn btn-secondary "
                style={{ fontSize: "11px", width: "130px" }}
                data-testing-id={"handovertorider" + props.index}
                onClick={() => {
                  handleButton("handedOver");
                }}
                disabled={props?.order.status !== "orderPickedUp"}
              >
                Handover to Rider
              </button>
            )}
            {(props?.order.status === "readyToShip" ||
              props?.order.status === "riderAssigned" ||
              props?.order.status === "orderPickedUp" ||
              props?.order.status === "handedOver") && (
              <div
                data-testing-id={"TrackThisOrder" + props.index}
                className="viewDV "
                onClick={() => setTrackOrderModal(true)}
              >
                Track This Order
              </div>
            )}
            {props?.order.status === "delivered" && (
              <div
                data-testing-id={"TrackThisOrder" + props.index}
                className="viewDV "
                onClick={() => setTrackOrderModal(true)}
              >
                Track This Order
              </div>
            )}
            <a
              href={`/order-detail/${props?.order?._id}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => event.stopPropagation()}
            >
              <div
                data-testing-id={"viewBtn_order" + props.index}
                className="viewDV extraView "
              >
                {" "}
                View{" "}
              </div>
            </a>
          </div>
        </div>
        <div className="tableBody">
          <div className="firtChild">
            <>
              {props.order.items && props.order.items.length > 0 ? (
                (newValueInfo
                  ? props.order.items
                  : props.order.items.slice(0, 1)
                ).map((product: any, index: any) => (
                  // <a
                  //   href={`/order-detail/${props?.order?._id}`}
                  //   target="_blank"
                  //   rel="noopener noreferrer"
                  //   onClick={(event) => event.stopPropagation()}
                  // >
                  // </a>

                  <div
                    className="orderCard"
                    key={index}
                    onClick={(event) => {
                      const target = event.target as HTMLElement; // Type assertion
                      if (!target.closest(".copy-icon")) {
                        window.open(
                          `/order-detail/${props?.order?._id}`,
                          "_blank"
                        );
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="profile">
                      <img src={product.productImage} alt="" />
                    </div>
                    <div className="contentDv">
                      <h4 title={product.productName}>{product.productName}</h4>
                      <div className="d-flex justify-content-start align-items-center gap-1">
                        <p>
                          Color Family:{" "}
                          <span>
                            {product.variants
                              .map((variant: any) => variant.value.name || "-")
                              .join(", ")}
                          </span>
                        </p>
                      </div>
                      <div
                        style={{ width: "170px" }}
                        className="d-flex justify-content-start align-items-center gap-1"
                      >
                        <p className="sellerSku">
                          Seller SKU: <span>{product?.sku}</span>
                        </p>
                        <i
                          className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                          data-testing-id="copyColor_order"
                          onClick={(event) => {
                            event.stopPropagation(); // Stop event bubbling
                            navigator.clipboard.writeText(product?.sku);
                            // toast.success("SKU copied!", { autoClose: 1000 });
                            setShowModal({ isVisible: true, color: true });
                            setErrorMessage("SKU Copied!.");
                            setTimeout(() => {
                              setShowModal({ isVisible: false, color: false });
                            }, 1000);
                            return;
                          }}
                        ></i>
                      </div>
                    </div>
                    <div className="priceDV">
                      <h4>
  Rs.{" "}
  {Number.isFinite(product?.overallItemSummary?.productPrice)
    ? Math.ceil(product.overallItemSummary.productPrice)
    : Number.isFinite(product?.price)
    ? Math.ceil(product.price)
    : "0"}
</h4>

                      <p className="text-danger">QTY {product.quantity}</p>
                    </div>
                  </div>
                ))
              ) : (
                <h2>No Data Found!</h2>
              )}
            </>
          </div>
          <div className="contentDv">
            <div className="tabelItemDv">
              <div className="secondChild">
                <div className="tabeBodyChild">
                  <div className="delivery">
                    {/* <h4>Rs.     {typeof props?.order?.orderSummary?.total === "number"
                        ? props.order.orderSummary.total.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        : "0.00"}</h4> */}
<h4>
  Rs.{" "}
  {Number.isFinite(props?.order?.orderSummary?.total)
    ? Math.ceil(props.order.orderSummary.total)
    : "0"}
</h4>

                        
                    <div className="dekiveryType">
                      <div className="dot"></div>
                      <p>{props?.order?.paymentMethodData?.name}</p>
                    </div>
                  </div>
                </div>
                <div className="tabeBodyChild">
                  <div className="delivery">
                    <h4 className="commErce">Buypass Rider</h4>
                    <div className="dekiveryTime">3 Hours Delivery</div>
                  </div>
                </div>
                <div className="tabeBodyChild">
                  <div className="newOrderDV">
                    <div className="newOrder">
                      <div className="dot"></div>
                      <p style={{ textTransform: "capitalize" }}>
                        {formattedStatus}
                      </p>
                    </div>
                    <div
                      className={`type ${
                        props.order.status === "readyToShip" ||
                        props.order.status === "riderAssigned" ||
                        props.order.status === "orderPickedUp" ||
                        !newValueInfo
                          ? "grid-layoutt"
                          : "column-layoutt"
                      }`}
                    >
                        <div
                        className="itemDv"
                        data-testing-id="viewInvoice_ManualOrder"
                        onClick={() => {
                          if (
                          props.order.status !== "orderPlaced" &&
                          props.order.status !== "pending"
                          ) {
                          openInvoice(props.order._id);
                          }
                        }}
                        style={{
                          cursor:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending"
                            ? "not-allowed"
                            : "pointer",
                          opacity:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending"
                            ? 0.5
                            : 1,
                          pointerEvents:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending"
                            ? "none"
                            : "auto",
                        }}
                        >
                        <img src={invoice} alt="" />
                        <p>Invoice</p>
                        </div>
                        <div
                        className="itemDv"
                        data-testing-id="viewPicklist_ManualOrder"
                        onClick={() => {
                          if (
                          props.order.status !== "orderPlaced" &&
                          props.order.status !== "pending"
                          ) {
                          openPicklist(props.order._id);
                          }
                        }}
                        style={{
                          cursor:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending"
                            ? "not-allowed"
                            : "pointer",
                          opacity:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending"
                            ? 0.5
                            : 1,
                          pointerEvents:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending"
                            ? "none"
                            : "auto",
                        }}
                        >
                        <img src={invoice} alt="" />
                        <p>Picklist</p>
                        </div>
                        <div
                        className="itemDv"
                        data-testing-id="viewAWb_ManualOrder"
                        onClick={() => {
                          if (
                          props.order.status !== "orderPlaced" &&
                          props.order.status !== "pending"  
                          ) {
                          openrAwb(props.order._id);
                          }
                        }}
                        style={{
                          cursor:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending" || props.order.status === "orderAccepted"
                            ? "not-allowed"
                            : "pointer",
                          opacity:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending" || props.order.status === "orderAccepted"
                            ? 0.5
                            : 1,
                          pointerEvents:
                          props.order.status === "orderPlaced" ||
                          props.order.status === "pending" || props.order.status === "orderAccepted"
                            ? "none"
                            : "auto",
                        }}
                        >
                        <img src={invoice} alt="" />
                        <p>AWB</p>
                        </div>
                      <div
                        className="itemDv"
                        data-testing-id="viewRiderHandover_EcommerceOrders"
                        onClick={() => {
                          if (props.order.status === "handedOver" || props.order.status === "delivered") {
                            openRiderHandover(props.order._id);
                          }
                        }}
                        style={{
                          cursor:
                            props.order.status === "handedOver" || props.order.status === "delivered"
                              ? "pointer"
                              : "not-allowed",
                          opacity:
                            props.order.status === "handedOver" || props.order.status === "delivered"
                              ? 1
                              : 0.5,
                          pointerEvents:
                            props.order.status === "handedOver" || props.order.status === "delivered"
                              ? "auto"
                              : "none",
                        }}
                      >
                        <img src={invoice} alt="" />
                        <p className="para-width">Rider Handover</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className=" lastChild"
                style={{ display: "flex", justifyContent: "end" }}
              >
                {props.order.status === "orderAccepted" &&
                  !props?.order?.orderPackageImage?.length &&
                  newValueInfo === false && (
                    <div className="buttonAppro">
                      <button
                        type="button"
                        className="btn btn-secondary ms-auto"
                        disabled={!props?.order?.orderPackageImage?.length}
                        data-testing-id={"ReadyToShip" + props.index}
                        onClick={() => {
                          handleButton("readyToShip");
                        }}
                      >
                        Ready To Ship
                      </button>
                      <div
                        data-testing-id={"vedioUploadBtn_order" + props.index}
                        className="videoPro"
                        onClick={() => setProofModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={add}
                          alt=""
                          style={{ width: "12px", height: "12px" }}
                        />{" "}
                        Video Upload
                      </div>
                    </div>
                  )}
                {props.order.status === "orderAccepted" &&
                  newValueInfo === true && (
                    <div className="buttonAppro">
                      <button
                        type="button"
                        className="btn btn-secondary ms-auto"
                        disabled={!props?.order?.orderPackageImage?.length}
                        data-testing-id={"ReadyToShip" + props.index}
                        onClick={() => {
                          handleButton("readyToShip");
                        }}
                      >
                        Ready To Ship
                      </button>

                      <div style={{ width: "120px" }}></div>
                    </div>
                  )}
                {props?.order?.orderPackageImage?.length &&
                  newValueInfo === false && (
                    <>
                      {props?.order?.status === "orderAccepted" && (
                        <div className="buttonAppro">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            data-testing-id="readyToShipButton_EcommerceOrderHistory"
                            disabled={!props?.order?.orderPackageImage?.length}
                            onClick={() => {
                              handleButton("readyToShip");
                            }}
                          >
                            Ready to Ship
                          </button>

                          <div
                            data-testing-id="viewBtn_order"
                            className="videoPro"
                          >
                            <img src={tick} alt="" /> Video Proof
                          </div>
                        </div>
                      )}
                    </>
                  )}
              </div>
            </div>

            {newValueInfo === true && (
              <>
                {(props?.order.status === "readyToShip" ||
                  props?.order.status === "riderAssigned" ||
                  props?.order.status === "orderPickedUp" ||
                  props?.order.status === "handedOver" ||
                  props?.order.status === "riderReached") && (
                  <div className="shipingDv">
                    <div className="tabRowDV">
                      {OnboardingTabs.map((tab, index) => {
                        const isCompleted =
                          user?.storeStatus?.[tab.value] || false;
                        const hasOrderAcceptedBySeller =
                          props?.order?.activities?.orders?.some(
                            (order: any) =>
                              order.type === "Seller Assigning Rider"
                          );
                        const hasSellerAssignedRider =
                          props?.order?.activities?.orders?.some(
                            (order: any) =>
                              order.type === "Seller Assigned Rider"
                          );
                        const hasRiderReached =
                          props?.order?.activities?.orders?.some(
                            (order: any) => order.type === "Rider Picked Up"
                          );
                        const hasHandover =
                          props?.order?.activities?.orders?.some(
                            (order: any) =>
                              order.type === "Rider Reached At Your Destination"
                          );

                        const showTickForFirstStep =
                          hasOrderAcceptedBySeller && index === 0;
                        const showRiderForSecondStep =
                          hasSellerAssignedRider && index === 1;
                        const showBoxRiderForThirdStep =
                          hasRiderReached && index === 2;
                        const showTickForFourthStep =
                          hasHandover && index === 3;

                        const isSpecialProgress =
                          showTickForFirstStep ||
                          showRiderForSecondStep ||
                          showBoxRiderForThirdStep ||
                          showTickForFourthStep;

                        return (
                          <div key={tab.value} className="tabSteps">
                            <div
                              className={`tab-circle ${
                                activeTabIndex === index || isCompleted
                                  ? "active"
                                  : "inactive"
                              }`}
                            >
                              {index === 0 ? (
                                hasOrderAcceptedBySeller ? (
                                  <img
                                    src={yellowTick}
                                    alt="Order Accepted"
                                    className="done-step-icon"
                                  />
                                ) : (
                                  <img
                                    src={clock}
                                    alt="Waiting for Order"
                                    className="waiting-icon"
                                  />
                                )
                              ) : index === 1 && hasSellerAssignedRider ? (
                                <Link
                                  to="/Seller-Chat"
                                  state={{ order: props.order }}
                                >
                                  <div
                                    className="d-flex justify-content-around align-items-center"
                                    style={{
                                      width: "105px",
                                      padding: "3px",
                                      height: "34px",
                                      borderRadius: "30px",
                                      background: "#FCFF00",
                                    }}
                                  >
                                    <img
                                      src={rider}
                                      alt="Rider Assigned"
                                      style={{ width: "27px", height: "27px" }}
                                    />
                                    <h1
                                      style={{
                                        color: "#0877FF",
                                        margin: "0px",
                                        font: "14px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Talk
                                    </h1>
                                    <img
                                      src={smjText}
                                      style={{ width: "21px", height: "21px" }}
                                      alt=""
                                    />
                                  </div>
                                </Link>
                              ) : index === 2 && hasRiderReached ? (
                                <img
                                  src={yellowTick}
                                  alt="Rider Reached At Your Destination"
                                  className="done-step-icon"
                                />
                              ) : index === 3 && hasHandover ? (
                                <img
                                  src={boxRider}
                                  alt="Step Completed"
                                  className="box-rider-icon"
                                />
                              ) : isCompleted ? (
                                <img
                                  src={yollow}
                                  alt="Step Completed"
                                  className="done-step-icon"
                                />
                              ) : (
                                index + 1
                              )}
                            </div>
                            {index !== OnboardingTabs.length - 1 && (
                              <div
                                className={`progress-line ${
                                  activeTabIndex > index || isCompleted
                                    ? "active"
                                    : ""
                                } ${
                                  isSpecialProgress ? "special-progress" : ""
                                }`}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                    {OnboardingTabs && OnboardingTabs.length
                      ? (() => {
                          const hasOrderAcceptedBySeller =
                            props?.order?.activities?.orders?.some(
                              (order: any) =>
                                order.type === "Seller Assigning Rider"
                            );
                          const hasSellerAssignedRider =
                            props?.order?.activities?.orders?.some(
                              (order: any) =>
                                order.type === "Seller Assigned Rider"
                            );
                          const hasRiderReached =
                            props?.order?.activities?.orders?.some(
                              (order: any) => order.type === "Rider Picked Up"
                            );
                          const hasHandover =
                            props?.order?.activities?.orders?.some(
                              (order: any) =>
                                order.type ===
                                "Rider Reached At Your Destination"
                            );
                          return (
                            <div className="orderShipinTIm">
                              <div
                                className={`shipTimging ${
                                  hasOrderAcceptedBySeller ? "ColorBlack" : ""
                                }`}
                              >
                                <h4>Finding a Rider</h4>
                                <p>
                                  Searching for the nearest available rider.
                                </p>
                              </div>
                              <div
                                className={`shipTimging ${
                                  hasSellerAssignedRider ? "ColorBlack" : ""
                                }`}
                              >
                                <h4>Rider Assigned</h4>
                                <p>
                                  Your rider has been found and is on the way.
                                </p>
                              </div>
                              <div
                                className={`shipTimging ${
                                  hasRiderReached ? "ColorBlack" : ""
                                }`}
                              >
                                <h4>Rider Arrived</h4>
                                <p>
                                  Give the parcel to the rider and confirm
                                  pickup.
                                </p>
                              </div>
                              <div
                                className={`shipTimging ${
                                  hasHandover ? "ColorBlack" : ""
                                }`}
                              >
                                <h4>Handover Parcel</h4>
                                <p>
                                  Give the parcel to the rider and confirm
                                  pickup.
                                </p>
                              </div>
                            </div>
                          );
                        })()
                      : null}
                  </div>
                )}

                {props?.order && newValueInfo === true && (
                  <>
                    {/* {props.order.status === "orderAccepted" && (
                      <button
                        type="button"
                        className="btn btn-secondary ms-auto"
                        disabled={!props?.order?.orderPackageImage?.length}
                        data-testing-id={'ReadyToShip' + props.index}
                        onClick={() => {
                          handleButton("readyToShip");
                        }}
                      >
                        Ready To Ship
                      </button>
                    )} */}
                    {props.order.status === "orderAccepted" && (
                      <div className="videoBorder">
                        <div
                          className="videoUploadMul"
                          onClick={() => setProofModal(true)}
                          data-testing-id={"videoUploader" + props.index}
                        >
                          <h6>
                            Video Proof <br /> Uploaded
                          </h6>
                        </div>
                        <div className="videoBoxMain">
                          <div
                            style={{ position: "relative", display: "flex" }}
                          >
                            {orderImages.length > 0 &&
                              orderImages.map((item: any, index: number) => {
                                return (
                                  <div
                                    key={item._id}
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                      margin: "5px",
                                    }}
                                  >
                                    <div className="videoFixer">
                                      <video
                                        src={item.url}
                                        controls
                                        onClick={() => openViewer(item.url)}
                                      />
                                    </div>
                                    <img
                                      src={close}
                                      className="close"
                                      onClick={() => handleClearImage(index)}
                                      style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    )}
                    {/* {props.order.status === "orderAccepted" && (
                      <div className="videoBorder">
                        <div
                          className="videoUploadMul"
                          onClick={() => setProofModal(true)}
                        >
                          <h6>
                            Video Proof <br /> Uploaded
                          </h6>
                        </div>
                        <div className="videoBoxMain">
                          <img src={proof} />
                        </div>
                      </div>
                    )} */}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div
          className="openCLoseView"
          onClick={() => {
            toggleOption();
          }}
        >
          <>
            {newValueInfo === false && (
              <>
                <img
                  src={viewMOre}
                  alt=""
                  data-testing-id={`viewMore_order_${props.index}`}
                />
                <p>View More</p>
              </>
            )}
            {newValueInfo === true && (
              <>
                <img
                  src={viewMOre}
                  alt=""
                  className="viewLess"
                  data-testing-id="viewLess_order"
                />
                <p>View Less</p>
              </>
            )}
          </>
        </div>
      </Card>
    </>
  );
};

export default OrderHistory;
